import React from 'react';
import { CONSTANTS } from '../../data';

interface MobileTabNavigationProps {
  activeTab: 'elements' | 'workspace' | 'ai';
  onTabSwitch: (tab: 'elements' | 'workspace' | 'ai') => void;
}

export const MobileTabNavigation: React.FC<MobileTabNavigationProps> = ({
  activeTab,
  onTabSwitch
}) => {
  return (
    <div className="mobile-tab-nav">
      {CONSTANTS.RESPONSIVE.mobileTabs.map(tab => (
        <button
          key={tab.id}
          className={`mobile-tab-btn ${activeTab === tab.id ? 'active' : ''}`}
          onClick={() => onTabSwitch(tab.id as 'elements' | 'workspace' | 'ai')}
        >
          <span className="tab-icon">{tab.icon}</span>
          <span className="tab-label">{tab.label}</span>
        </button>
      ))}
    </div>
  );
};
